import classnames from "classnames";
import capitalize from "lodash/capitalize";
import lowerCase from "lodash/lowerCase";
import pluralize from "pluralize";
import {FaCircleXmark, FaGaugeHigh} from "react-icons/fa6";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {renderFormattedQuantity} from "@/lib/format.tsx";
import {PlanLimit} from "@/lib/types/accounts.ts";
import {Plan} from "@/lib/types/billing.ts";

import css from "./PlanRow.module.css";

export interface PlanRowProps {
  plan: Plan;
  name: string;
  limits?: PlanLimit;
  unlimited?: boolean;
  suffix?: string;
  pluralizeName?: boolean;
  tooltip?: string;
}

export const PlanRow = ({name, limits, unlimited, suffix, tooltip, plan, pluralizeName = true}: PlanRowProps) => {
  const included = limits?.included;
  const used = limits?.used || 0;
  const limit = limits?.limit || 0;
  const plansWithLimit: Plan[] = [Plan.Starter, Plan.Essential];
  const overLimit = plansWithLimit.includes(plan) && used > limit;
  const overLimitTooltip = `You currently have ${used} ${pluralize(name, used)} configured and the ${capitalize(lowerCase(plan))} plan supports ${
    limit > 0 ? limit : "none"
  }. Please delete ${used - limit} ${pluralize(name, used - limit)} to subscribe to ${capitalize(lowerCase(plan))}.`;
  return (
    <div className="d-flex justify-content-between">
      <div className={classnames(css.PlanRowIndicator, css.PlanRowIndicatorRed)}>
        {overLimit && (
          <TooltipWrapper toolTip={overLimitTooltip}>
            <span>
              <FaGaugeHigh />
            </span>
          </TooltipWrapper>
        )}
      </div>
      <TooltipWrapper toolTip={tooltip}>
        <div>
          <h2 className={classnames(css.PlanRowHeader, "w-100 text-center fw-semibold fs-5")}>
            {included === 0 ? (
              <small className="pulse-color-gray-400">
                <FaCircleXmark size="18" />
              </small>
            ) : unlimited ? (
              "Unlimited"
            ) : (
              renderFormattedQuantity(included || 0)
            )}{" "}
            {suffix && pluralize(suffix, included)}
          </h2>
          <div className="w-100 text-center fw-normal">{pluralizeName ? pluralize(name, included) : name}</div>
        </div>
      </TooltipWrapper>
      <div className={css.PlanRowIndicator}></div>
    </div>
  );
};
